import { useQuery } from '@tanstack/react-query';
import { getLatestPortCalls } from '@api';
import { GEOGRAPHICAL_TYPES, DEFAULT_NUM_PORT_CALLS } from '@constants';
import { useSegment } from '@hooks';

export const useLatestPortCalls = (props) => {
  const { segment } = useSegment();

  const cleanedProps = { ...props };
  if (cleanedProps.geoIds) {
    cleanedProps.geoIds = cleanedProps.geoIds.filter((id) => id !== null && id !== undefined);
  }

  if (cleanedProps.imos) {
    cleanedProps.imos = cleanedProps.imos.filter(
      (imo) => imo !== null && imo !== undefined && !isNaN(imo)
    );
  }

  return useQuery({
    queryKey: ['vesselsLatestPortCalls', cleanedProps, segment.id],
    queryFn: ({ signal }) =>
      getLatestPortCalls(
        {
          geographicalType: GEOGRAPHICAL_TYPES.ALL,
          segmentTypeId: segment.id,
          numberOfPortCalls: DEFAULT_NUM_PORT_CALLS,
          ...cleanedProps
        },
        signal
      ),
    enabled:
      Object.keys(cleanedProps).length > 0 &&
      (!cleanedProps.geoIds || cleanedProps.geoIds.length > 0)
  });
};
